<template>
  <div class="dealer-manage">
    <page-header title="供应商管理" icon="el-icon-user-solid" />
    <el-card class="box-card">
      <!-- 搜索区域 -->
      <div class="filter-container">
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="供应商名称">
            <el-input
              v-model="queryParams.dealerName"
              placeholder="请输入供应商名称"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="queryParams.status"
              placeholder="请选择状态"
              clearable
              size="small"
            >
              <el-option label="全部" :value="-1" />
              <el-option label="启用" :value="1" />
              <el-option label="禁用" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              size="small"
              @click="handleQuery"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh"
              size="small"
              @click="resetQuery"
            >重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 操作按钮区域 -->
      <div class="operation-container">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="handleAdd"
        >新增供应商</el-button>
        
      </div>

      <!-- 表格区域 -->
      <el-table
        v-loading="loading"
        :data="dealerList"
      >
        <el-table-column label="供应商名称" prop="dealerName" align="center" />
        <el-table-column label="负责人" prop="charger" align="center" />
        <el-table-column label="负责人电话" prop="chargePhone" align="center" />
        <el-table-column label="联系人" prop="contact" align="center" />
        <el-table-column label="联系人电话" prop="contactPhone" align="center" />
        <!-- <el-table-column label="联系地址" prop="address" align="center" /> -->
        <!-- <el-table-column label="办公电话" prop="phone" align="center" /> -->
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="handleStatusChange(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-document"
              @click="handleFiles(scope.row)"
            >文件</el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParams.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>

      <!-- 经销商表单对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="经销商名称" prop="dealerName">
            <el-input v-model="form.dealerName" placeholder="请输入供应商名称" />
          </el-form-item>
          <el-form-item label="负责人" prop="charger">
            <el-input v-model="form.charger" placeholder="请输入负责人姓名" />
          </el-form-item>
          <el-form-item label="负责人电话" prop="chargePhone">
            <el-input v-model="form.chargePhone" placeholder="请输入负责人电话" />
          </el-form-item>
          <el-form-item label="联系人" prop="contact">
            <el-input v-model="form.contact" placeholder="请输入联系人姓名" />
          </el-form-item>
          <el-form-item label="联系人电话" prop="contactPhone">
            <el-input v-model="form.contactPhone" placeholder="请输入联系人电话" />
          </el-form-item>
          <el-form-item label="联系地址" prop="address">
            <el-input v-model="form.address" placeholder="请输入联系地址" />
          </el-form-item>
          <el-form-item label="办公电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入办公电话" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 经销商文件对话框 -->
      <el-dialog title="经销商文件" :visible.sync="fileDialogVisible" width="800px" append-to-body>
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :headers="headers"
          :data="uploadData"
          :before-upload="beforeUpload"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          multiple
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过10MB</div>
        </el-upload>
        
        <el-table :data="fileList" style="margin-top: 20px">
          <el-table-column label="文件名称" prop="fileName" />
          <el-table-column label="文件类型" prop="fileKind" width="100" />
          <el-table-column label="上传时间" prop="createdAt" width="180" />
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleDownload(scope.row)"
              >下载</el-button>
              <el-button
                type="text"
                size="small"
                @click="handleDeleteFile(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
import PageHeader from '@/components/common/PageHeader'

export default {
  name: 'DealerManage',
  components: {
    PageHeader
  },
  data() {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 经销商表格数据
      dealerList: [],
      // 弹出层标题
      dialogTitle: '',
      // 是否显示弹出层
      dialogVisible: false,
      // 是否显示文件出层
      fileDialogVisible: false,
      // 查询参数
      queryParams: {
        page: 1,
        size: 10,
        supplier_name: '',
        status: -1,
        contact: '',
        contactPhone: ''
      },
      // 表单参数
      form: {
        supplier_id: '',
        dealerName: '',
        chargePhone: '',
        supplier_kind: 1,
        supplier_name: '',
        charger: '',
        charge_tel: '',
        contact: '',
        contactPhone: '',
        contact_tel: '',
        contactAddr: '',
        address: '',
        phone: '',
        grade: 1,
        status: 1,
        remark: ''
      },
      // 表单校验
      rules: {
        dealerName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        charger: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        chargePhone: [
          { required: true, message: '请输入负责人电话', trigger: 'blur' }
        ]
      },
      // 文件列表
      fileList: [],
      // 上传地址
      uploadUrl: process.env.VUE_APP_BASE_API + '/api/v1/dealer-files/upload',
      // 上传请求头
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      // 上传参数
      uploadData: {
        dealerId: undefined
      }
    }
  },
  created() {
    // 从路由获取代理商ID
    this.getList()
    const { agentId } = this.$route.query
    if (agentId) {
      this.queryParams.agentId = agentId
      this.form.agentId = agentId
      
    }
  },
  methods: {
    /** 查询经销商列表 */
    async getList() {
      try {
        this.loading = true
        const res = await request({
          url: '/api/v1/supplier/list',
          method: 'POST',
          data: {
            page: this.queryParams.page,
            size: this.queryParams.size,
            supplier_name: this.queryParams.dealerName || '',
            status: this.queryParams.status !== -1 ? this.queryParams.status : undefined
          }
        })

        if (res.status === 1 && res.list) {
          // 修改数据映射，确保 supplier_id 正确映射
          this.dealerList = res.list.map(item => ({
            supplier_id: item.SupplierID, // 确保这里的映射正确
            dealerName: item.SupplierName,
            charger: item.Charger,
            chargePhone: item.ChargeTel,
            contact: item.Contact,
            contactPhone: item.ContactTel,
            address: item.Address,
            phone: item.Phone,
            status: item.Status,
            remark: item.Remark,
            createBy: item.CreateBy,
            createAt: item.CreatedAt,
            updateBy: item.UpdateBy,
            updateAt: item.UpdatedAt,
            soft: item.Soft
          }))
          this.total = res.total || 0
        } else {
          this.dealerList = []
          this.total = 0
          this.$message.error(res.msg || '获取供应商列表失败')
        }
      } catch (error) {
        console.error('获取供应商列表错误:', error)
        this.$message.error('获取供应商列表失败')
        this.dealerList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    
    /** 搜索按钮操作 */
    async handleQuery() {
      this.queryParams.page = 1
      await this.getList()
    },
    
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        page: 1,
        size: 10,
        dealerName: '',
        status: -1
      }
      this.getList()
    },
    
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.dialogTitle = '添加供应商'
      this.dialogVisible = true
    },
    
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      this.form = { ...row }
      this.dialogTitle = '修改供应商'
      this.dialogVisible = true
    },
    
    /** 删除按钮操作 */
    async handleDelete(row) {
      try {
        await this.$confirm('是否确认删除该供应商?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        // 打印要删除的ID，用于调试
        console.log('删除的供应商ID:', row.supplier_id)

        const res = await request({
          url: '/api/v1/supplier/delete',
          method: 'POST',
          data: {
            supplier_id: row.supplier_id // 确保这里使用正确的ID
          }
        })

        if (res.status === 1) {
          // 删除成功后立即更新列表
          await this.getList()
          this.$message.success('删除成功')
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除供应商错误:', error)
          this.$message.error('删除失败')
        }
      }
    },
    
    /** 表单重置 */
    reset() {
      this.form = {
        supplier_id: '',
        supplier_kind: 1,
        dealerName: '',
        charge: '',
        chargePhone: '',
        contact: '',
        contactPhone: '',
        address: '',
        grade: 1,
        status: 1,
        remark: ''
      }
      this.$refs.form && this.$refs.form.resetFields()
    },
    
    /** 提交按钮 */
    async submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const params = {
              supplier_id: this.form.supplier_id || '',
              supplier_kind: this.form.supplier_kind,//供应商类型
              supplier_name: this.form.dealerName,//供应商名称
              charger: this.form.charger,//负责人
              charge_tel: this.form.chargePhone,//负责人电话
              contact: this.form.contact || '',//联系人 
              contact_tel: this.form.contactPhone || '',//联系人电话
              address: this.form.address || '',//联系地址
              grade: this.form.grade || 1,//等级
              status: this.form.status || 1,//状态
              remark: this.form.remark || '',//备注
              soft: 0//软删除
            }

            const res = await request({
              url: '/api/v1/supplier/save',
              method: 'POST',
              data: params
            })

            if (res.status === 1) {
              this.$message.success('保存成功')
              this.dialogVisible = false
              this.getList()
            } else {
              this.$message.error(res.msg || '保存失败')
            }
          } catch (error) {
            console.error('保存供应商错误:', error)
            this.$message.error('保存失败')
          }
        }
      })
    },
    
    /** 文件相关操作 */
    handleFiles(row) {
      this.uploadData.dealerId = row.dealerId
      this.getFileList(row.dealerId)
      this.fileDialogVisible = true
    },
    
    getFileList(dealerId) {
      request({
        url: '/api/v1/dealer-files/list',
        method: 'get',
        params: { dealerId }
      }).then(response => {
        this.fileList = response.data
      })
    },
    
    beforeUpload(file) {
      const isValidType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isValidType) {
        this.$message.error('只能上传JPG/PNG/PDF格式文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!')
        return false
      }
      return true
    },
    
    handleUploadSuccess(response) {
      this.$message.success('上传成功')
      this.getFileList(this.uploadData.dealerId)
    },
    
    handleUploadError() {
      this.$message.error('上传失败')
    },
    
    handleDownload(row) {
      window.open(row.fileUrl)
    },
    
    handleDeleteFile(row) {
      this.$confirm('是否确认删除该文件?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return request({
          url: '/api/v1/dealer-files/delete',
          method: 'post',
          data: { fileId: row.fileId }
        })
      }).then(() => {
        this.getFileList(this.uploadData.dealerId)
        this.$message.success('删除成功')
      })
    },
    
    /** 状态修改 */
    handleStatusChange(row) {
      request({
        url: '/api/v1/dealers/change-status',
        method: 'post',
        data: {
          dealerId: row.dealerId,
          status: row.status
        }
      }).then(() => {
        this.$message.success('状态修改成功')
      }).catch(() => {
        row.status = row.status === 1 ? 0 : 1
      })
    },
    
    /** 分页相关操作 */
    handleSizeChange(val) {
      this.queryParams.size = val
      this.getList()
    },
    
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.dealer-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .filter-container {
    padding-bottom: 10px;
  }

  .operation-container {
    margin-bottom: 20px;
  }

  .pagination-container {
    padding: 20px 0;
    text-align: right;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .upload-demo {
    margin-bottom: 20px;
  }

  .el-upload__tip {
    line-height: 1.2;
    margin-top: 5px;
    color: #909399;
  }
}
</style> 